import { createSelector } from '@reduxjs/toolkit';
import { TState } from 'store/types';
import { AppState } from './appSlice';

export const getAppState = (state: TState): AppState => state.appState;

export const getEnv = createSelector(getAppState, ({ env }) => env);
